import { StoreAction } from "../../@core/constants/action";

const initalState = {
  noteList: [],
};

export default function (state = initalState, action) {
  switch (action.type) {
    case StoreAction.GET_NOTE: {
      return {
        ...state,
        noteList: action.payload,
      };
    }
    default:
      return state;
  }
}
